import { render, staticRenderFns } from "./PAQuotePost.vue?vue&type=template&id=2dec82bc&"
import script from "./PAQuotePost.vue?vue&type=script&lang=js&"
export * from "./PAQuotePost.vue?vue&type=script&lang=js&"
import style0 from "./PAQuotePost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAQuotePost.vue"
export default component.exports